import { TG } from '@/shared/api/api';

let cloudUnavailable = false;

export const getCloudItem = async (key: string, defaultValue: string) => {
  try {
    if (!cloudUnavailable && TG?.CloudStorage?.getItem) {
      const value = await new Promise<string | null>((resolve) => {
        TG.CloudStorage.getItem(key, (err: any, value: string | null) => {
          if (err) {
            console.warn('[CloudStorage] get error:', err);
            cloudUnavailable = true;
            resolve(null);
          } else {
            resolve(value);
          }
        });
      });

      if (value !== null && value !== '') return value;
    }

    if (typeof window !== 'undefined') {
      const localValue = localStorage.getItem(key);
      if (localValue !== null && localValue !== '') return localValue;
    }

    return defaultValue;
  } catch (e) {
    console.warn('[getCloudFlag] fallback error', e);
    return defaultValue;
  }
};

export const setCloudItem = async (key: string, value: string) => {
  try {
    // 1. CloudStorage
    if (!cloudUnavailable && TG?.CloudStorage?.setItem) {
      await new Promise<void>((resolve) => {
        TG.CloudStorage.setItem(key, String(value), (err: any) => {
          if (err) {
            console.warn('[CloudStorage] set error:', err);
            cloudUnavailable = true;
            if (typeof window !== 'undefined') localStorage.setItem(key, String(value));
          }
          resolve();
        });
      });
      return;
    }

    // 2. fallback localStorage
    if (typeof window !== 'undefined') localStorage.setItem(key, String(value));
  } catch (e) {
    console.warn('[setCloudFlag] fallback error', e);
    if (typeof window !== 'undefined') localStorage.setItem(key, String(value));
  }
};